<template>
  <img v-if="data.picture!='-'" :src="sanitizeLink(data.picture)" width="100" height="100" />
  <span v-else>-</span>
 </template>


 <script>


 export default {
   data () {
     return {
       data:{}
     }
   },
   methods:{
    sanitizeLink(link) {
      return `https://api.igeotechgps.com/uploads/${link}`
    },
   }
 }
 </script>
